@if (mode=='about') {
  <div style="padding: 0px 25px;">
    <h6 mat-dialog-title>{{'label.gb.about' | translate}}</h6>
    <div mat-dialog-content style="min-height: fit-content; width: 30rem; justify-content: center;">
      <!-- <div class="mb-10">{{translate('label.gb.title.merlin.pcn')}}</div> -->
      <!-- <br /> -->
      <!-- <div>Merlin.net™ Web Application v11.6.rev3</div>
      <div>
        Merlin.net™ MN6000 HF Web Application v10.1, GTIN 05414734510035
      </div>
      <div>Merlin.net™ MN5000 UnitySim, GTIN 05414734509732</div> -->
      <div [innerHTML]="about_txt_eponly"></div>
      <br />
      <div style="max-width: 80%; max-height: 80%; vertical-align: middle;">
        <div class="row">
          @if (showRegulatoryImage('crmManufacturer')) {
            <img
              src="./assets/images/CRM Manufacturer ABT.svg" alt
              width="36%" style="padding: 10px"
              >
          }
          @if (showRegulatoryImage('importerEcRepAbt')) {
            <img
              src="./assets/images/Importer EC REP ABT.svg" alt
              width="36%" style="padding: 20px"
              >
          }
          @if (showRegulatoryImage('CEMark')) {
            <img
              src="./assets/images/CE_mark 0123.svg" alt
              width="12%"
              >
          }
          @if (showRegulatoryImage('medicalDevice')) {
            <img
              src="./assets/images/Medical Device.svg" alt
              width="24%" style="padding: 10px"
              >
          }
          @if (showRegulatoryImage('consultInstructions')) {
            <img
              src="./assets/images/Consult instructions for use www_abbott.svg" alt
              width="24%" style="padding: 10px"
              >
          }
          @if (showRegulatoryImage('chRep')) {
            <img
              src="./assets/images/CH-REP_CH-Importer.svg" alt
              width="36%" style="padding: 10px"
              >
          }
          @if (showRegulatoryImage('rxOnly')) {
            <img
              src="./assets/images/RxOnly.svg" alt
              width="24%" style="padding: 10px 0px"
              >
          }
          @if (showRegulatoryImage('abbottMedical')) {
            <img
              src="./assets/images/US Site Symbol with address.svg" alt
              width="36%"
              >
          }
        </div>
      </div>
      <div align="end">
        <button mat-raised-button class="merlin-button" mat-button mat-dialog-close>
          {{'label.gb.close' | translate}}
        </button>
      </div>
    </div>
  </div>
} @else {
  <h6 mat-dialog-title [innerHTML]="translate('leftNav.practice_site')"></h6>
  <div mat-dialog-content>
    <div class="mb-10">{{'msg.prac_site_diag_body1.text'| translate}}</div>
    <br />
    <a href="javascript:void(0)" (click)="onPracticeSiteLink()">{{practiceSiteLink}}</a
      >
      <br /><br />
      <div>{{ 'msg.prac_site_diag_body2.text' | translate }}</div>
      <div>
        {{ 'msg.prac_site_diag_body3.text' | translate }} {{practiceSitePassword}}
      </div>
      <div>
        {{ 'msg.prac_site_diag_body4.text' | translate }} WeCareForHearts!
      </div>
    </div>
    <div align="end" mat-dialog-actions>
      <button mat-raised-button class="merlin-button" mat-button mat-dialog-close>
        {{'label.gb.close' | translate}}
      </button>
    </div>
  }
